import { GetterTree } from "vuex";

import { IState, IRootState } from "./state-types";
import { IUserAccount } from "../userAccount";

export const getters: GetterTree<IState, IRootState> = {
    activeUser(state: IState): IUserAccount {
        return state.activeUser;
    },

    activeUserName(state: IState): string {
        if (state && state.activeUser && state.activeUser.userName)
            return state.activeUser.userName;
        else
            return  "";
    },

    modelIsActive(state: IState): boolean {
        if (state.currentModelId)
            return true;
        else
            return false;
    },

    currentModelId(state: IState): string {
        return state.currentModelId;
    },

    currentNodePath(state: IState): string {
        return state.currentNodePath;
    },

    nodeModifiedNotification(state: IState): string {
        return state.nodeModifiedNotification;
    }

};


// WEBPACK FOOTER //
// ./ClientApp/infrastructure/state/state-getters.ts